<div class="battery-level-wrapp">
  <i class="icon battery-empty-icon" [inlineSVG]="'#emptyBattery'"></i>
  <span class="battery-level" [ngStyle]="{ color: levelColor }"> {{ batteryLevel }}% </span>
</div>
